import React from 'react';
import { ThemedText, ThemedView } from "@app/theme";
import { isMobileView } from "@sharedComponents/stack/utils";

export const PhotoInstructions: React.FC = () => (
    <ThemedView
        borderRadius={"sm"}
        padding={"md"}
        backgroundColor={"bg-fill-warning"}
        mt={"md"}
    >
        <ThemedText variant={"b3m"} color={"text-primary"}>
            For faster approval
        </ThemedText>
        {!isMobileView() ? (
            <ThemedText variant={"b4r"} mt={"sm"} color={"text-secondary"}>
                • Please remove your glasses and cap before capturing the photo
            </ThemedText>
        ) : (
            <>
                <ThemedText variant={"b4r"} mt={"sm"} color={"text-secondary"}>
                    • Please remove your glasses and cap before
                </ThemedText>
                <ThemedText variant={"b4r"} color={"text-secondary"} ml={"sm"}>
                    capturing the photo
                </ThemedText>
            </>
        )}
        <ThemedText variant={"b4r"} color={"text-secondary"}>
            • Make sure to take the photo in a well-lit area
        </ThemedText>
    </ThemedView>
);